import { card } from 'creditcards';

export default (number) => {
  return card.isValid(
    card.parse(number)
  );
}
